import { COMMON_CONTENT } from './common';

export const ABOUT_CONTENT = {
  breadcrumb: 'About Us',
  hero: {
    badge: 'Our Story',
    title: 'Joy in Every Hug',
    description: `Founded in 2026, ${COMMON_CONTENT.brand.name} brings comfort and joy to all ages.`,
  },
  stats: [
    { number: '50K+', label: 'Happy Customers' },
    { number: '100+', label: 'Unique Designs' },
    { number: '4.9', label: 'Average Rating' },
    { number: '15+', label: 'Years of Love' },
  ],
  values: {
    title: 'Our Values',
    items: [
      { icon: 'Heart', title: 'Made with Love', description: 'Crafted with care' },
      { icon: 'Star', title: 'Quality First', description: 'Premium materials' },
      { icon: 'Sparkles', title: 'Safe for All', description: 'Rigorous standards' },
      { icon: 'Shield', title: 'Secure Trust', description: 'We stand by our friends' },
    ],
  },
  story: {
    title: 'Crafted with Passion',
    content: [
      'Each friend is designed in our studio with love.',
      'From sketch to stitch, we prioritize quality.',
    ],
    image: '/img/product-1.jpg',
    stats: { number: '50+', label: 'Craftsmen', plusMembers: '+99' },
  },
  team: {
    title: 'Meet the Team',
    description: 'The talent behind the toys',
    members: [
      { name: 'Sarah Johnson', role: 'Founder', icon: 'User' },
      { name: 'Mike Chen', role: 'Designer', icon: 'User' },
      { name: 'Emma Wilson', role: 'Quality', icon: 'User' },
      { name: 'David Park', role: 'Support', icon: 'User' },
    ],
  },
  cta: {
    title: 'Join the Family!',
    description: 'Find your perfect companion today.',
    buttonLabel: 'Shop Now',
    buttonPath: '/shop',
  },
} as const;

export const CONTACT_CONTENT = {
  breadcrumb: 'Contact Us',
  title: 'Get In Touch',
  description: 'Have a question? We are here to help you!',
  info: {
    address: { icon: 'MapPin', title: 'Visit Us', lines: [COMMON_CONTENT.brand.address] },
    email: { icon: 'Mail', title: 'Email', value: COMMON_CONTENT.brand.email },
    phone: { icon: 'Phone', title: 'Call Us', value: COMMON_CONTENT.brand.phone },
    hours: { icon: 'Clock', title: 'Hours', lines: ['Mon-Fri: 9am-6pm', 'Sat: 10am-4pm'] },
  },

  form: {
    title: 'Send Us a Message',
    subtitle: "We'll get back to you as soon as possible.",
    fields: {
      name: { label: 'Name', placeholder: COMMON_CONTENT.placeholders.name },
      email: { label: 'Email', placeholder: COMMON_CONTENT.placeholders.email },
      subject: { label: 'Subject', placeholder: 'How can we help?' },
      message: { label: 'Message', placeholder: 'Tell us more...' },
    },
    submitButton: 'Send Message',
  },
  supportHighlight: {
    badge: 'Support Priority',
    title: 'Need faster help?',
    description: 'Our team responds within 2 hours during business hours.',
  },
} as const;

export const FAQ_CONTENT = {
  breadcrumb: 'FAQ',
  title: 'Frequently Asked Questions',
  subtitle: 'Everything you need to know',
  categories: [
    { id: 'orders', label: 'Orders & Shipping', icon: 'Package' },
    { id: 'returns', label: 'Returns & Refunds', icon: 'RotateCcw' },
    { id: 'products', label: 'Products', icon: 'ShoppingBag' },
    { id: 'payment', label: 'Payment', icon: 'CreditCard' },
  ],
  questions: [
    {
      id: 'q1',
      category: 'orders',
      question: 'How long does shipping take?',
      answer: 'Standard shipping takes 3-5 business days.',
    },
    {
      id: 'q2',
      category: 'returns',
      question: 'What is your return policy?',
      answer: 'We offer a 30-day return policy for unused items.',
    },
  ],
} as const;
